import { ValuesType } from 'utility-types';
import { makeRequest, CommonRequestOptions } from './makeRequest';
import { Guide } from './guides';
import { Question } from './questions';
import { Device, Category, WikiPage } from './wikis';
import { Image } from './common';

type SuggestionDoctypeIndex = {
   guide: Guide;
   device: Device;
   category: Category;
   question: Question;
   wiki: WikiPage;
   all: Guide | Device | Category | Question;
};

export type GetSuggestionRequestOptions = CommonRequestOptions & {
   doctypes?: keyof SuggestionDoctypeIndex;
   showAllLanguages?: boolean;
   includeUnreleased?: boolean;
};

export async function getSuggestions<Doctype extends keyof SuggestionDoctypeIndex>(
   searchTerm: string,
   { doctypes, showAllLanguages, includeUnreleased, ...common }: GetSuggestionRequestOptions = {}
): Promise<ValuesType<Pick<SuggestionDoctypeIndex, Doctype>>[]> {
   const response = await makeRequest('get', `suggest/${encodeURIComponent(searchTerm)}`, {
      ...common,
      query: {
         doctypes,
         showAllLanguages,
         includeUnreleased,
      },
   });
   return response.results;
}

export type GetUsersAndTeamsSuggestionRequestOptions = CommonRequestOptions & {
   userLimit?: number;
   teamLimit?: number;
};

export type UserSuggestion = {
   userid: number;
   username: string;
   image: Image;
};
export type TeamSuggestion = {
   teamid: number;
   name: string;
   imageUrl: string;
};

export type UsersAndTeamsSuggestions = {
   users: UserSuggestion[];
   teams: TeamSuggestion[];
};

export async function getUsersAndTeamsSuggestions(
   searchTerm: string,
   { userLimit, teamLimit, ...common }: GetUsersAndTeamsSuggestionRequestOptions = {}
) {
   return await makeRequest('get', `suggest/usersAndTeams/${encodeURIComponent(searchTerm)}`, {
      ...common,
      query: {
         userLimit,
         teamLimit,
      },
   });
}
